(() => {
  const initialized = new WeakSet();
  function init(scope) {
    scope.querySelectorAll('.feestxl-product-section').forEach(section => {
      if (initialized.has(section)) return;
      initialized.add(section);
      const input = section.querySelector('[data-feestxl-qty]');
      const pack = section.querySelector('[data-fxlp-pack]');
      const output = pack?.querySelector('[data-fxlp-pack-total]');
      function update() {
        if (!input) return;
        const quantity = Number(input.value);
        const min = Number(input.min) || 1;
        const step = Number(input.step) || 1;
        const max = input.max ? Number(input.max) : Infinity;
        const valid = Number.isInteger(quantity) && quantity >= min && quantity <= max && (quantity - min) % step === 0;
        if (output) {
          output.hidden = !valid;
          if (valid) output.textContent = (quantity === 1 ? pack.dataset.summaryOne : pack.dataset.summary).replace('__PACKS__', String(quantity)).replace('__PIECES__', String(quantity * Number(pack.dataset.packCount)));
        }
        const minus = section.querySelector('[data-qty-minus]');
        const plus = section.querySelector('[data-qty-plus]');
        if (minus) minus.disabled = quantity <= min;
        if (plus) plus.disabled = quantity + step > max;
      }
      input?.addEventListener('input', update);
      input?.addEventListener('change', update);
      update();
      section.querySelectorAll('[data-fxlp-series]').forEach(rail => {
        const track = rail.querySelector('[data-fxlp-series-track]');
        const buttons = [...rail.querySelectorAll('[data-fxlp-slide]')];
        const sync = () => buttons.forEach(button => { button.disabled = Number(button.dataset.fxlpSlide) < 0 ? track.scrollLeft < 2 : track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; });
        buttons.forEach(button => button.addEventListener('click', () => track.scrollBy({ left: Number(button.dataset.fxlpSlide) * (track.firstElementChild.getBoundingClientRect().width + 16), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' })));
        track.addEventListener('scroll', sync, { passive: true });
        new ResizeObserver(sync).observe(track);
        sync();
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', () => init(document));
})();
